function DrinkSub(props){
    return (
        <div className={'drink-sub'}>
            {props.name}
        </div>
    )
}

export default DrinkSub